module.exports = __webpack_public_path__ + "img/syukyaku-top-022.a492d8c2.jpg";